import { NationalIdentificationNumberCountry } from '@dreryk/personal-external-identifier-common-api';

import {
   Bean,
   commonTranslationKeys,
   createTranslatedText,
   FieldControllerProps,
   getCurrentLocale,
   ValidationRules,
} from '@dreryk/react-common';
import { Select, StyledMaxWidth, useSelectContext } from '@dreryk/react-components';

import { personalDataTranslationKeys } from '../../../translations';
import {
   createNationalIdentificationNumberCountryFilter,
   nationalIdentificationNumberCountryIsoCodeGetter,
} from '../../common.utils';

const VALIDATION_RULES: ValidationRules<Bean> = {
   required: true,
};

const getCountryLabel = (item?: NationalIdentificationNumberCountry): string =>
   item?.getValue().getName(getCurrentLocale()) ?? '';

const nationalIdentificationNumberCountries = NationalIdentificationNumberCountry.searchAll(getCurrentLocale());
const CountriesList = (): JSX.Element => {
   const { searchText } = useSelectContext();
   const filteredCountries = nationalIdentificationNumberCountries.filter(
      createNationalIdentificationNumberCountryFilter(searchText)
   );
   if (!filteredCountries.length) {
      return <Select.NoItems testId={'noCountries'} />;
   }
   return (
      <Select.List items={filteredCountries} keyExtractor={nationalIdentificationNumberCountryIsoCodeGetter}>
         {(country: NationalIdentificationNumberCountry) => (
            <Select.Item<NationalIdentificationNumberCountry>
               item={country}
               testId={nationalIdentificationNumberCountryIsoCodeGetter(country)}
               label={<Select.Highlight node={createTranslatedText(getCountryLabel(country))} />}
            />
         )}
      </Select.List>
   );
};

type NationalIdentificationNumberCountryFieldProps = FieldControllerProps<
   'nationalIdentificationNumberCountry',
   NationalIdentificationNumberCountry | null
>;

export const NationalIdentificationNumberCountryField = (
   props: NationalIdentificationNumberCountryFieldProps
): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={308}>
         <Select<NationalIdentificationNumberCountry>
            testId={'nationalIdentificationNumberCountry'}
            triggerLabelExtractor={getCountryLabel}
            controller={props.register('nationalIdentificationNumberCountry', VALIDATION_RULES)}
            defaultValue={null}
            label={personalDataTranslationKeys.nationalIdentificationNumberCountry.label}
            placeholder={commonTranslationKeys.choose}
            maxHeight={190}
         >
            <CountriesList />
         </Select>
      </StyledMaxWidth>
   );
};
